export const adanceddefpagetext = {
    changedatashift: "Décaler la donnée dans le temps",
    changedatatimefiltering: "Filtrer la période de donnée",
    datashiftmonth: "Mois",
    datashiftday: "Jours",
    datashifthour: "Heures",
    fromday:"Du",
    fromhour:"De",
    today:"Au",
    tohour:"A",
}

export const alertpagetext = {
    hideclosed: "Cacher les alertes fermées ou acquittées",

}